<template>
  <div v-if="care_vital_sign.care_has_vital_signs.length > 0">
    <p
      :class="[
        'm-0 text-thirteen upper-text',
        parseFloat(item.description) >= 36.1 &&
          parseFloat(item.description) <= 37.2 &&
          'color-green',
        parseFloat(item.description) >= 37.3 &&
          parseFloat(item.description) <= 38.4 &&
          'color-orange',
        parseFloat(item.description) >= 35.1 &&
          parseFloat(item.description) <= 36 &&
          'color-orange',
        (parseFloat(item.description) > 38.4 ||
          parseFloat(item.description) < 35.1) &&
          'color-red',
      ]"
    >
      {{ item.description }}
      {{ item.abbreviation }}
    </p>
    <p class="mb-1 worksansr text-twelve upper-text">
      CADASTRADO POR: {{ item.user_name }}
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  name: "Temperatura",
  props: {
    care_vital_sign: Object,
    item: Object,
  },
};
</script>